'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CURRENT_BOARD_ID_SET = exports.CURRENT_BOARD_ID_SET = 'CURRENT_BOARD_ID_SET';

// Constant for the current board ID so that other selectors can wait until there's a board ID available
var UNINITIALISED = exports.UNINITIALISED = 'UNINITIALISED';


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/currentBoardId/currentBoardIdConstants.js
// module id = 461
// module chunks = 0